import { render, staticRenderFns } from "./bindingMobilePhoneNumber.vue?vue&type=template&id=22f6426e&scoped=true&"
import script from "./bindingMobilePhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./bindingMobilePhoneNumber.vue?vue&type=script&lang=ts&"
import style0 from "./bindingMobilePhoneNumber.vue?vue&type=style&index=0&id=22f6426e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6426e",
  null
  
)

export default component.exports